import request from '@/plugins/request'


export function LoginVideo(username,password) {
 return request({
  method: 'get',
  url: `/api/v1/login?username=${username}&password=${password}`,
  headers: {
  }
 })
}
export function getVideoList(token,serial,code) {
 return request({
  method: 'get',
  url: `/api/v1/stream/start?serial=${serial}&code=${code}`,
  headers: {
   token: token
  }
 })
}
// 摄像头控制
export function ControlVideo(token, serial, code, command) {
 return request({
  method: 'get',
  url: `/api/v1/control/ptz?serial=${serial}&code=${code}&command=${command}`,
  headers: {
   token: token
  }
 })
}
// 停止播放视频流
export function StopVideo(token, serial, code) {
 return request({
  method: 'get',
  url: `/api/v1/stream/stop?serial=${serial}&code=${code}`,
  headers: {
   token: token
  }
 })
}